<button
  type="button"
  class="ss-global-search__trigger"
  aria-label="Buscar eventos, produtos, clientes e telas"
  aria-haspopup="dialog"
  [attr.aria-expanded]="isOpen"
  (click)="open()">
  <lucide-icon name="search" [size]="16" aria-hidden="true"></lucide-icon>
  <span class="ss-global-search__placeholder">Buscar eventos, produtos, clientes, telas…</span>
  <kbd class="ss-global-search__kbd">{{ shortcutLabel }}</kbd>
</button>

<div *ngIf="isOpen" class="ss-global-search__backdrop" (click)="close()"></div>

<div *ngIf="isOpen" class="ss-global-search__panel" role="dialog" aria-label="Busca global">
  <div class="ss-global-search__field">
    <lucide-icon name="search" [size]="16" aria-hidden="true"></lucide-icon>
    <input
      #searchInput
      type="text"
      class="ss-global-search__input"
      placeholder="Buscar eventos, produtos, clientes, telas…"
      autocomplete="off"
      role="combobox"
      aria-autocomplete="list"
      aria-controls="ss-global-search-results"
      [attr.aria-expanded]="flatItems.length > 0"
      [attr.aria-activedescendant]="activeIndex >= 0 ? 'ss-global-search-option-' + activeIndex : null"
      [value]="term"
      (input)="onInput($any($event.target).value)"
      (keydown)="onInputKeydown($event)" />
    <lucide-icon
      *ngIf="state === 'loading'"
      name="loader-circle"
      [size]="16"
      class="ss-global-search__spinner"
      aria-hidden="true">
    </lucide-icon>
    <button type="button" class="ss-global-search__close" aria-label="Fechar busca" (click)="close()">
      <lucide-icon name="x" [size]="16" aria-hidden="true"></lucide-icon>
    </button>
  </div>

  <div id="ss-global-search-results" class="ss-global-search__results" role="listbox" aria-live="polite">
    <p *ngIf="!hasMinChars && !groups.length" class="ss-global-search__message">
      Digite ao menos 2 caracteres para buscar.
    </p>

    <p *ngIf="hasMinChars && state === 'loading' && !groups.length" class="ss-global-search__message">
      Buscando…
    </p>

    <div *ngIf="hasMinChars && state === 'error'" class="ss-global-search__message ss-global-search__message--error">
      <lucide-icon name="circle-alert" [size]="16" aria-hidden="true"></lucide-icon>
      <span>Não foi possível buscar agora.</span>
      <button type="button" class="ss-global-search__retry" (click)="retry()">Tentar de novo</button>
    </div>

    <p *ngIf="hasMinChars && state === 'done' && !groups.length" class="ss-global-search__message">
      Nenhum resultado para “{{ term.trim() }}”.
    </p>

    <ng-container>
      <section *ngFor="let group of groups" class="ss-global-search__group" role="group" [attr.aria-label]="group.label">
        <header class="ss-global-search__group-header">
          <span>{{ group.label }}</span>
          <span class="ss-global-search__count">{{ group.total }}</span>
        </header>

        <div
          *ngFor="let item of group.items"
          role="presentation"
          class="ss-global-search__row"
          [class.is-active]="indexOf(item) === activeIndex"
          (mouseenter)="activeIndex = indexOf(item)">
          <button
            type="button"
            role="option"
            class="ss-global-search__option"
            [id]="'ss-global-search-option-' + indexOf(item)"
            [attr.aria-selected]="indexOf(item) === activeIndex"
            (click)="select(item)">
            <span class="ss-global-search__option-icon">
              <lucide-icon [name]="item.icon || group.icon" [size]="15" aria-hidden="true"></lucide-icon>
            </span>
            <span class="ss-global-search__option-text">
              <span class="ss-global-search__option-title">{{ item.title }}</span>
              <span *ngIf="item.subtitle" class="ss-global-search__option-subtitle">{{ item.subtitle }}</span>
            </span>
          </button>
          <span *ngIf="item.actions?.length" class="ss-global-search__actions">
            <button
              *ngFor="let action of item.actions"
              type="button"
              tabindex="-1"
              class="ss-icon-button"
              [ngClass]="'ss-icon-button--' + action.definition.variant"
              [attr.aria-label]="action.label"
              [attr.data-ss-tooltip]="action.label"
              (click)="openAction(action.route)">
              <lucide-icon [name]="action.definition.icon" [size]="15" aria-hidden="true"></lucide-icon>
            </button>
          </span>
        </div>

        <button
          *ngIf="group.key !== 'screens' && group.total > group.items.length"
          type="button"
          class="ss-global-search__see-all"
          (click)="seeAll(group)">
          Ver todos ({{ group.total }})
        </button>
      </section>
    </ng-container>
  </div>

  <footer class="ss-global-search__footer">
    <span><kbd class="ss-global-search__kbd">↑</kbd><kbd class="ss-global-search__kbd">↓</kbd> navegar</span>
    <span><kbd class="ss-global-search__kbd">Enter</kbd> abrir</span>
    <span><kbd class="ss-global-search__kbd">{{ editShortcutLabel }}</kbd> editar</span>
    <span><kbd class="ss-global-search__kbd">Esc</kbd> fechar</span>
  </footer>
</div>
